export const textbox = {
  textbox: {
    position: {
      top: 80,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 60,
    },
    font_family: 'Arial',
    text: 'Text Here',
    font_size: 11,
    color: 'cf2d2d',
  },
}

export const image = {
  image: {
    position: {
      top: 20,
      left: 10,
      angle: 0.0,
    },
    size: {
      width: 200,
      height: 100,
    },
    name: '',
    image: '',
  },
}
